/**
 * The valid field types
 * @type {Object}
 */
const fieldTypes = [
    'select',
    'textarea',
    'text',
    'url',
    'email',
    'int',
    'float',
    'checkbox',
    'radio',
    'group',
    'date',
    'time',
    'repeater',
];

export default fieldTypes;
